import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight, Instagram } from "lucide-react";
import { thumb } from "../lib/api";

export default function FeaturedCreators() {
  const [creators, setCreators] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/creators-featured").then(({ data }) => setCreators(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (creators.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % creators.length), 6000);
    return () => clearInterval(t);
  }, [creators.length]);

  if (creators.length === 0) return null;
  const c = creators[idx];

  return (
    <section data-testid="featured-creator-section" className="bg-[#C6FF33] border-y-2 border-[#121212] py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="flex items-center justify-between gap-6 flex-wrap mb-10">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase font-bold">Featured creator</p>
            <h2 className="font-serif font-black text-5xl text-[#121212] mt-3">Meet this week's <em>maker</em>.</h2>
          </div>
          {creators.length > 1 && (
            <div className="flex gap-2">
              {creators.map((_, i) => (
                <button
                  key={i}
                  data-testid={`featured-dot-${i}`}
                  onClick={() => setIdx(i)}
                  aria-label={`Show creator ${i + 1}`}
                  className={`w-3 h-3 border-2 border-[#121212] ${i === idx ? "bg-[#121212]" : "bg-transparent"}`}
                />
              ))}
            </div>
          )}
        </div>
        <Link to={`/creators/${c.id}`} data-testid={`featured-link-${c.id}`} className="grid md:grid-cols-2 gap-10 items-center fade-in">
          <div className="aspect-square overflow-hidden border-2 border-[#121212] bg-white">
            {c.photo_url ? <img src={thumb(c.photo_url, 800)} alt={c.name} className="w-full h-full object-cover" /> :
              <div className="w-full h-full flex items-center justify-center font-serif font-black text-9xl text-[#121212]/40">{c.name[0]}</div>}
          </div>
          <div>
            <h3 className="font-serif font-black text-6xl text-[#121212] leading-[0.95]">{c.name}</h3>
            {c.specialties?.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {c.specialties.slice(0, 4).map(s => <span key={s} className="px-3 py-1 bg-white text-xs tracking-[0.2em] uppercase font-bold border-2 border-[#121212]">{s}</span>)}
              </div>
            )}
            {c.bio && <p className="mt-6 text-[#121212] text-lg leading-relaxed">{c.bio}</p>}
            <div className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-[#121212] text-[#F2E9D8] text-xs tracking-[0.25em] uppercase font-bold">
              View profile <ArrowRight size={16} />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
